import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { CollaboratorEntry } from "..";
import { RIF, t, useCurrentProjectState, useCurrentWorkspaceState } from "../../lib";
import { useSelectTheme, useSelectCollaborators } from "../../store";
import { IWorkspaceCollaborator, WorkspaceCollaboratorType } from "../../shared/db";

export type CollaboratorListType = "projectCollaborator" | "workspaceCollaborator";
interface CollaboratorListProps {
  workspaceId: string;
  setRemovingCollaborator?: Dispatch<SetStateAction<any>>;
  searchingPhrase: string;
  listType: CollaboratorListType;
  setShowingManageCollaboratorPopup?: Dispatch<SetStateAction<boolean>>;
  setEditingCollaborator?: Dispatch<SetStateAction<IWorkspaceCollaborator | null>>;
}

export const CollaboratorList = (props: CollaboratorListProps) => {
  const { color } = useSelectTheme();

  const {
    workspaceId,
    setRemovingCollaborator,
    searchingPhrase,
    listType,
    setShowingManageCollaboratorPopup,
    setEditingCollaborator,
  } = props;

  const collaboratorsState = useSelectCollaborators();
  // const userProfile = useSelectProfile()
  const { projectId } = useCurrentProjectState();
  const { workspaceId: currentWorkspaceId, workspace: currentWorkspace } = useCurrentWorkspaceState(
    { projectId },
  );
  // const role = workspacesState.roleInWorkspaces[workspaceId] || 'owner'

  const [collaboratorList, setCollaboratorList] = useState<IWorkspaceCollaborator[]>([]);
  useEffect(() => {
    if (collaboratorsState[workspaceId]) {
      setCollaboratorList(Object.values(collaboratorsState[workspaceId]));
    }
  }, [workspaceId, collaboratorsState]);

  const processIndex = (originIndex: number) => {
    if (originIndex < 8) {
      if (listType === "projectCollaborator") {
        return `0${originIndex + 1}`;
      }
      return `0${originIndex + 2}`;
    }
    return `${originIndex + 1}`;
  };

  const handleSetRemovingCollaborator = (collaborator: any) => {
    if (setRemovingCollaborator) setRemovingCollaborator(collaborator);
  };

  const ownerProfile = currentWorkspace?.ownerProfile;

  return (
    <div
      css={{
        border: `1px solid ${color.grey_100}`,
        borderBottom: "none",
        width: "100%",
        background: color.white,
        marginBottom: "48px",
      }}
    >
      <CollaboratorEntry />
      {RIF(
        listType === "workspaceCollaborator" &&
          currentWorkspace?.ownerProfile?.id &&
          currentWorkspace?.ownerProfile?.email.includes(searchingPhrase),
        <CollaboratorEntry
          {...{
            index: "01",
            setRemovingCollaborator: handleSetRemovingCollaborator,
            key: "01",
            collaborator: ownerProfile
              ? {
                  identityId: t.unwrap(ownerProfile.identityId),
                  id: t.unwrap(ownerProfile.id),
                  createdAt: "",
                  updatedAt: "",
                  workspaceId: t.unwrap(currentWorkspaceId),
                  type: "owner" as WorkspaceCollaboratorType,
                  profile: ownerProfile,
                }
              : undefined,
          }}
        />,
      )}
      {collaboratorList
        .filter(
          (c: IWorkspaceCollaborator) =>
            (listType === "workspaceCollaborator" &&
              c.type !== WorkspaceCollaboratorType.ProjectCollaborator) ||
            (listType === "projectCollaborator" &&
              c.type === WorkspaceCollaboratorType.ProjectCollaborator &&
              (!projectId || c.projectCollaboratorList?.some((p) => p.projectId === projectId))),
        )
        .filter((c: IWorkspaceCollaborator) => c.profile?.email?.includes(searchingPhrase))
        .map((collaborator: IWorkspaceCollaborator, index: number) => {
          {
            return (
              <CollaboratorEntry
                {...{
                  index: processIndex(index),
                  collaborator,
                  setRemovingCollaborator: handleSetRemovingCollaborator,
                  key: index,
                  setShowingManageCollaboratorPopup,
                  setEditingCollaborator,
                }}
              />
            );
          }
        })}
    </div>
  );
};
